import { httpCreate } from './http';

const http = httpCreate('/shop/api/product-coupon-detail');

export const productCouponDetail = {
	/**
	 * 获取优惠券实时库存
	 * @param {number} couponId 优惠卷id
	 */
	getCouponSurplusNum(couponId) {
		return http.get(`/surplusNum/${couponId}`);
	},
};
